import { apiClient } from './client';
import type {
  AuthResponse,
  ChangePasswordPayload,
  MessageResponse,
  RegisterPayload,
  UpdateProfilePayload,
  UserResponse,
} from './types';

export const authApi = {
  async register(payload: RegisterPayload): Promise<MessageResponse> {
    const { data } = await apiClient.post<MessageResponse>('/auth/register', payload);
    return data;
  },

  async login(email: string, password: string): Promise<AuthResponse> {
    const { data } = await apiClient.post<AuthResponse>('/auth/login', { email, password });
    return data;
  },

  async logout(refreshToken: string): Promise<void> {
    await apiClient.post('/auth/logout', { refreshToken });
  },

  async confirmEmail(userId: string, token: string): Promise<MessageResponse> {
    const { data } = await apiClient.post<MessageResponse>('/auth/confirm-email', { userId, token });
    return data;
  },

  async resendConfirmation(email: string): Promise<MessageResponse> {
    const { data } = await apiClient.post<MessageResponse>('/auth/resend-confirmation', { email });
    return data;
  },

  async forgotPassword(email: string): Promise<MessageResponse> {
    const { data } = await apiClient.post<MessageResponse>('/auth/forgot-password', { email });
    return data;
  },

  async resetPassword(userId: string, token: string, newPassword: string): Promise<MessageResponse> {
    const { data } = await apiClient.post<MessageResponse>('/auth/reset-password', {
      userId,
      token,
      newPassword,
    });
    return data;
  },
};

export const meApi = {
  async get(): Promise<UserResponse> {
    const { data } = await apiClient.get<UserResponse>('/me');
    return data;
  },

  async update(payload: UpdateProfilePayload): Promise<UserResponse> {
    const { data } = await apiClient.put<UserResponse>('/me', payload);
    return data;
  },

  async changePassword(payload: ChangePasswordPayload): Promise<MessageResponse> {
    const { data } = await apiClient.post<MessageResponse>('/me/change-password', payload);
    return data;
  },
};
